import React from 'react';
import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const StyledContent = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'&.sticky-header': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
		'#title-text': {
			color: `${token('color.text')}`,
			font: token('font.heading.medium'),
			padding: `${token('space.200')} 0px 0px 0px`,
			alignItems: 'center',
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
			'#heading-title-text': {
				font: token('font.heading.medium'),
			},
		},
		paddingRight: token('space.200'),
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const StyledContainer = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	"[data-test-id='header-animated-box']": {
		width: '100%',
		left: 0,
	},
});

export const StickyHeaderContainer: React.FC<{
	children?: React.ReactNode;
}> = ({ children }) => (
	<StyledContainer>
		<StyledContent id="content-header-container" data-testid="sticky-header-content">
			{children}
		</StyledContent>
	</StyledContainer>
);
